<template>
  <div>
    <LandingBase :content="content" :numberApplications="numberApplications" v-if="content.type == 1"></LandingBase>
    <div class="" v-else v-html="content.landingContent"></div>
  </div>
</template>

<script>
import numberFilterMixin from '@/mixins/numberFilterMixin';
import heatMapToolMixin from '~/mixins/heatMapToolMixin';
import { saveRegisterLandingUrl } from '@/helpers/registerLanding';

export default {
  name: 'Landing',
  layout: 'frontend/lp-create',
  components: {
    LandingBase: () => import('@/components/particles/LandingBase.vue')
  },
  async asyncData({params, app, $frontendRepositories, redirect}) {
    const {url} = params;
    let content = {
      landingName: '#landing-name#',
      headerImage: 'https://dummyimage.com/579x819/ffffff/6c70a1.gif&text=landing-header-image',
      thumbImage: 'https://dummyimage.com/579x819/ffffff/6c70a1.gif&text=thumb_image',
      priceTitle: '#landing-price-title#',
      price: '#landing-price#',
      sale_price: '#landing-sale-price#',
      business: '#business_suggest#',
      field_prices: [],
      suitable_applications: [],
      fields: [],
      landingContent: '',
      type: 1,
      is_faq: false,
      faqs: [],
      is_review: false,
      reviews: [],
      is_media_post: false,
      media_posts: []
    }

    if(url) {
      // set content
      const { errResponse, data: responseData } = await $frontendRepositories.landing.showPublic(url)

      if(!errResponse) {
        const landing = responseData.data;
        saveRegisterLandingUrl(app.$cookies, url);

        content = {
          landingName: landing.application?.name,
          headerImage: landing.header_image,
          thumbImage: landing.thumb_image,
          priceTitle: landing.price_title,
          price: landing.application?.price || 0,
          sale_price: landing.application?.sale_price,
          business: landing.business_suggest,
          field_prices: landing.application?.field_prices || [],
          fields: landing.landing_fields,
          suitableApplications: landing.suitable_applications,
          landingContent: landing.content,
          type: landing.type,
          is_faq: landing.is_faq,
          faqs: landing.faqs,
          is_review: landing.is_review,
          reviews: landing.reviews,
          is_media_post: landing.is_media_post,
          media_posts: landing.media_posts
        }
      } else {
        return redirect('/lp/create')
      }
    } else {
      return redirect('/lp/create')
    }

    // get app number
    const {errResponse, data: numberResponseData} = await $frontendRepositories.landing.getNumberApplications();
    const numberApplications = errResponse ? 0 : numberResponseData.data;

    return {
      content,
      numberApplications
    }
  },
  mixins: [numberFilterMixin, heatMapToolMixin],
  data() {
    return {
      title: '',
      metaHeader: [],
    };
  },
  created() {
    this.title = this.content.landingName + '｜LegalScript書類作成'
    this.metaHeader = [
      {charset: 'utf-8'},
      { hid: 'og:site_name', property: 'og:site_name', content: 'LegalScript書類作成' },
      { hid: 'og:url', property: 'og:url', content: 'https://admin.legal-script.com/landing/' + this.$route.params.url },
      { hid: 'og:title', property: 'og:title', content: this.content.landingName + '｜LegalScript書類作成' },
      { hid: 'og:image', property: 'og:image', content: 'https://admin.legal-script.com/frontend/img/legal-script-application.png' },
      {
        hid: 'og:description',
        property: 'og:description',
        content: '簡単入力で「' + this.content.landingName +'」の書類作成を実現。100以上の無料テンプレート利用可能、途中保存と専門家監修のガイド付きで安心。'
      },
    ]
  },
  mounted() {
    const registerLandingUrl = this.$route.params?.url;

    if (registerLandingUrl) {
      saveRegisterLandingUrl(this.$cookies, registerLandingUrl);
      this.addRegisterLandingToLinks();
      // Custom scripts can create links or move banners outside this component.
      this.registerLinksObserver = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type === 'attributes') {
            this.addRegisterLandingToLinks(mutation.target);
          } else {
            mutation.addedNodes.forEach(node => this.addRegisterLandingToLinks(node));
          }
        });
      });
      this.registerLinksObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['href']
      });
    }
  },
  beforeDestroy() {
    if (this.registerLinksObserver) {
      this.registerLinksObserver.disconnect();
    }
  },
  methods: {
    addRegisterLandingToLinks(root = document.body) {
      const registerLandingUrl = this.$route.params?.url;
      if (!registerLandingUrl || root.nodeType !== 1) {
        return;
      }

      const links = Array.from(root.querySelectorAll('a[href]'));
      if (root.matches('a[href]')) {
        links.unshift(root);
      }
      links.forEach(link => {
        if (link.origin === window.location.origin && [
          '/auth/register-application',
          '/auth/login-application'
        ].includes(link.pathname)) {
          const url = new URL(link.href);
          Object.entries(this.$route.query).forEach(([key, value]) => {
            // Keep query parameters already specified by the custom link.
            if (!url.searchParams.has(key) && value !== undefined) {
              const values = Array.isArray(value) ? value : [value];
              values.forEach(item => url.searchParams.append(key, item == null ? '' : item));
            }
          });
          url.searchParams.set('registerLandingUrl', registerLandingUrl);
          const href = url.pathname + url.search + url.hash;
          // Avoid triggering the observer repeatedly for our own changes.
          if (link.getAttribute('href') !== href) {
            link.setAttribute('href', href);
          }
        }
      });
    }
  },
};
</script>
